import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { CustomPropValueDescriptor } from './model/customprop.value';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class CustomPropValueService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'CustomPropValueManagement',
      authService,
      config.CPMSConfig
    );
  }

  public create(customPropValue: CustomPropValueDescriptor): Promise<CustomPropValueDescriptor> {
    return super.post<CustomPropValueDescriptor>(
      new CustomPropValueDescriptor({
        id: undefined,
        href: undefined,
        customPropTypeId: customPropValue.customPropTypeId,
        relatedObjectId: customPropValue.relatedObjectId,
        value: customPropValue.value,
        modified: customPropValue.modified,
        deleted: customPropValue.deleted
      }));
  }
  
  public update(id: string, cpv: CustomPropValueDescriptor): Promise<CustomPropValueDescriptor> {
    return super.put<CustomPropValueDescriptor>(id, cpv);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  async GetList(v: View): Promise<List<CustomPropValueDescriptor>> {
    return await this.getCustomPropValues(v);
  }

  public getCustomPropValues(view?: View): Promise<List<CustomPropValueDescriptor>> {
    return super.get<List<CustomPropValueDescriptor>>(undefined, view);
  }

  async GetById(id: string): Promise<CustomPropValueDescriptor> {
    return await this.getById(id);
  }

  public getById(id: string): Promise<CustomPropValueDescriptor> {
    return super.get<CustomPropValueDescriptor>(id);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/customprop.value/customprop.value.service.ts